import { twMerge } from "tailwind-merge";

type Props = {
    step: number;
    className?: string;
};

export default function Progressbar({ step, className }: Props) {
    const style = twMerge("py-[8px] flex gap-[4px]", className);
    return (
        <ul className={style}>
            {Array.from({ length: 3 }).map((_, index) => {
                const isActive = index < step;
                return <li key={index} className={`${isActive ? "bg-[#4B632B]" : "bg-[#E5E5F1]"} flex-1 rounded-[2px]  h-[4px]`}></li>;
            })}
        </ul>
    );
}
